import { observer } from "mobx-react";
import React from "react";
import { Location, NavigateFunction, Params } from "react-router-dom";
import ActivityIcon from "../../../../../images/common/activity-blue.svg";
import { useSearchParams } from "react-router-dom";
import { ItemsStore, RolesAndPermissionStore } from "../store";
import { CustomLine } from "../styles";
import {
  CustomButton,
  CustomLabel,
  FlexContainer,
  Input,
  SingleSelect,
  withRouter,
} from "@mindmemobile/mm-shared-global";
import { ItemSideBarModel, MerchantAccount } from "../models";
import { ApplicationStatus, ItemDropDownOptions } from "../enums";
import NotificationBox from "./NotificationBox";
import SearchIcon from "../../../../../images/common/search-blue.svg";
import { AuthService } from "../services";
import MerchantAccountIcon from "../../../../../images/sidebar/merchant-accounts-icon-blue.svg";
import { MerchantAccountStore } from "../../../src/modules/merchantAccounts";
import styled from "styled-components";

interface IProps {
  navigate: NavigateFunction;
  params: Readonly<Params<string>>;
  location: Location;
  itemStore: ItemsStore;
  rightContent?: React.ReactNode;
  subRoute?: string | null;
  hideHeader?: boolean;
  showRightContent?: boolean;
  showMerchantAccount?: boolean;
  merchantAccounts: MerchantAccount[];
  merchantAccountId?: string;
  onChangeMerchantAccount: (merchantAccountId: string) => void;
  merchantAccountStore?: MerchantAccountStore;
  rolesAndPermissionStore?: RolesAndPermissionStore;
  showSearchInput?: boolean;
}
const DashboardHeader = styled.div`
  .dbHeader-wo-icon {
    margin-bottom: 20px;
  }
  .dpdn-db-topbar {
    margin-left: 7px;
    .select-header-span {
      width: auto;
      > div {
        width: auto;
      }
    }
    .options-menu {
      max-width: unset;
      width: auto;
      transform: translate(16px, 30px);
      border: 1px solid #ddd;
      li {
        padding: 0px 12px;
        white-space: nowrap;
      }
      .searchable-dropdown-input {
        padding-left: 12px !important;
      }
    }
  }
`;

const DashboardTopBar: React.FC<IProps> = ({
  itemStore,
  location,
  rightContent,
  navigate,
  subRoute,
  hideHeader = false,
  showRightContent = false,
  merchantAccounts,
  merchantAccountId,
  showMerchantAccount,
  onChangeMerchantAccount,
  merchantAccountStore,
  rolesAndPermissionStore,
  showSearchInput = false,
}) => {
  const [searchParams, setSearchParams] = useSearchParams();
  function breadCrumb() {
    if (!itemStore.breadCrumbData) return "";

    return (
      <>
        {itemStore.breadCrumbData.title && <CustomLine />}
        {itemStore.breadCrumbData.icon && (
          <img src={itemStore.breadCrumbData.icon} />
        )}
        {/* <StyledTooltip
          // bsPrefix="db-header-tooltip"
          tooltipText={itemStore.breadCrumbData.title}
          placement="bottom"
        > */}
        <CustomLabel className="db-header-title">
          {itemStore.breadCrumbData.title}
        </CustomLabel>
        {/* </StyledTooltip> */}
      </>
    );
  }

  const activeRoute = ItemSideBarModel.getActiveRoute(location);
  const showSwitch = activeRoute?.title === ItemDropDownOptions.Activity;

  function toggleTestMode() {
    isTestMode()
      ? setSearchParams({ testMode: "false" })
      : setSearchParams({ testMode: "true" });
    window.location.reload();
  }

  function isTestMode() {
    return searchParams.get("testMode")?.toLowerCase() === "true";
  }

  if (hideHeader) return null;
  const showHeaderContent = !AuthService.hideHeaderBar || showRightContent;
  const selectedMerchantAccount = merchantAccounts?.find(
    (item) => item.merchantAccountId === merchantAccountId
  );

  const activeMerchantAccounts =
    merchantAccounts?.filter(
      (m) => m.applicationStatus === ApplicationStatus.Active
    ) || [];

  const renderNotificationBox = () => {
    if (!merchantAccountStore) return null;
    return (
      <>
        {/* {!merchantAccountStore.hasMerchantAccounts() && (
          <NotificationBox
            descripton={
              "Link your existing merchant account or apply for a new one"
            }
            buttonCaption="Learn More"
            onClick={() => navigate("/app/merchant-accounts")}
          />
        )} */}
        {/* {!merchantAccountStore.hasAnyActiveMerchantAccount() && (
          <NotificationBox
            descripton={
              "Apply for your own merchant account to enable integrated payment processing..."
            }
            buttonCaption="Apply Now"
            onClick={() => {
              if (
                rolesAndPermissionStore &&
                rolesAndPermissionStore.hasManagePermission(
                  "Apply for Merchant Account"
                )
              ) {
                navigate("/app/merchant-accounts/create-new");
              }
            }}
          />
        )} */}
        {merchantAccountStore.hasSinglePendingMerchantAccount() && (
          <NotificationBox
            descripton={
              "A merchant application requires attention.  Click to review, finalize and submit."
            }
            buttonCaption="Complete Application"
            color="#DE5F85"
            bgColor="#FFF8FA"
            onClick={() =>
              navigate(
                `/app/merchant-accounts/success/${merchantAccountStore.getPendingMerchantAccountId()}`
              )
            }
          />
        )}
        {merchantAccountStore.hasNoActiveAccounts() &&
          !merchantAccountStore.hasSinglePendingMerchantAccount() && (
            <NotificationBox
              descripton={
                "Merchant applications require attention.  Click to review, finalize and submit."
              }
              buttonCaption="View Applications"
              onClick={() => navigate("/app/merchant-accounts")}
            />
          )}
      </>
    );
  };

  return (
    <DashboardHeader>
      {renderNotificationBox()}
      {showHeaderContent || showMerchantAccount || showSearchInput ? (
        <FlexContainer
          alignItems="center"
          // justifyContent="space-between"
          className="db-header-icons"
          padding="30px 30px 25px 0px"
        >
          {showHeaderContent && (
            <div className="db-header-sidebar">
              <FlexContainer
                alignItems="center"
                spacing={20}
                className="db-header-flex"
              >
                <img
                  src={ActivityIcon}
                  className="clickable"
                  onClick={() => navigate("/app/activity")}
                />
                <CustomLine />
                {activeRoute?.route !== "activity" && (
                  <img src={activeRoute?.icon} />
                )}

                <CustomLabel
                  fontWeight="600"
                  lineHeight="40px"
                  className="clickable"
                  onClick={() =>
                    itemStore.breadCrumbData?.route &&
                    navigate(itemStore.breadCrumbData.route)
                  }
                >
                  {activeRoute?.title || ""}
                </CustomLabel>

                {breadCrumb()}
                {subRoute && (
                  <FlexContainer alignItems="center" spacing={20}>
                    <CustomLine />

                    <CustomLabel>{subRoute || ""}</CustomLabel>
                  </FlexContainer>
                )}
              </FlexContainer>
            </div>
          )}
          {showMerchantAccount && activeMerchantAccounts.length > 0 && (
            <SingleSelect
              searchable={activeMerchantAccounts.length > 10}
              hasError={false}
              selectedKey={merchantAccountId || ""}
              emptySelection="Select Merchant Account"
              nameKeys={["name"]}
              valueKeys={["merchantAccountId"]}
              options={[activeMerchantAccounts]}
              onChange={(option) => {
                onChangeMerchantAccount &&
                  onChangeMerchantAccount(option.merchantAccountId);
              }}
              className="dpdn-no-separator dpdn-no-border dpdn-with-icons dpdn-db-topbar"
              customHeader={
                selectedMerchantAccount && (
                  <FlexContainer spacing={5} alignItems="center">
                    <img src={MerchantAccountIcon} />
                    <div>{selectedMerchantAccount?.name}</div>
                  </FlexContainer>
                )
              }
            />
          )}
          {/* {showSearchInput && (
            <FlexContainer
              spacing={5}
              alignItems="center"
              className="db-search-input"
              margin="0px 0px 0px 80px"
              justifyContent="flex-end"
            >
              <img src={SearchIcon} alt="search" />
              <Input
                type="text"
                value={""}
                onChange={(e) =>
                  itemStore.updateSearchValue(
                    e.target.value,
                    activeRoute?.title
                  )
                }
                placeholder="Search"
              />
            </FlexContainer>
          )} */}
          <div className="flex-auto-grow">
            <FlexContainer
              justifyContent={
                activeRoute?.route === "donations"
                  ? "space-between"
                  : "flex-end"
              }
              alignItems="center"
              spacing={10}
            >
              {showHeaderContent && (
                <div>
                  {activeRoute?.route === "donations" && (
                    <FlexContainer spacing={45} padding="0px 0px 0px 25px">
                      <CustomButton
                        height={"40px"}
                        onClick={() => itemStore.toggleDonorGridActive()}
                        bgColor="transparent"
                        color={
                          !itemStore.isDonorGirdActive ? "#556BB8" : "#2C3E50"
                        }
                        className={
                          !itemStore.isDonorGirdActive
                            ? "border-bottom-blue"
                            : ""
                        }
                        fontSize={"20px"}
                        fontWeight={600}
                        minWidth="100px"
                        width="100px"
                        padding="0px 5px"
                      >
                        Donations
                      </CustomButton>
                      <CustomButton
                        height={"40px"}
                        onClick={() => itemStore.toggleDonorGridActive()}
                        bgColor="transparent"
                        color={
                          itemStore.isDonorGirdActive ? "#556BB8" : "#2C3E50"
                        }
                        className={
                          itemStore.isDonorGirdActive
                            ? "border-bottom-blue"
                            : ""
                        }
                        fontSize={"20px"}
                        fontWeight={600}
                        minWidth="75px"
                        width="75px"
                        padding="0px 5px"
                      >
                        Donors
                      </CustomButton>
                    </FlexContainer>
                  )}
                </div>
              )}
              {/* {showHeaderContent && showSwitch && (
         <div>
           <FlexContainer alignItems="center" spacing={10}>
             <ToggleSwitch
               on={isTestMode()}
               onColor={isTestMode() ? "#FF8D5C" : "#AAAAAA"}
               offColor={isTestMode() ? "#FF8D5C" : "#AAAAAA"}
               onChange={() => toggleTestMode()}
             />{" "}
             <CustomLabel
               color={isTestMode() ? "#E58012" : "#AAAAAA"}
               fontSize="20px"
             >
               Test Mode
             </CustomLabel>
           </FlexContainer>
         </div>
       )} */}

              {showHeaderContent && rightContent && <>{rightContent}</>}
            </FlexContainer>
          </div>
        </FlexContainer>
      ) : (
        <div className="dbHeader-wo-icon"></div>
      )}
    </DashboardHeader>
  );
};

export default withRouter(observer(DashboardTopBar));
